import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AuthService } from './admin-app/services/auth.service';
import { Interceptor } from './core/interceptor';
import { TokenStorage } from './core/token.storage';

import { AppRoutingModule } from './core/app.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './core/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatToolbarModule, MatTabsModule, MatSidenavModule, MatListModule, MatButtonModule, MatIconModule } from "@angular/material";

import { AppComponent } from './app.component';

import { StatistiqueComponent } from './admin-app/statistique/statistique.component';
import { ImportComponent } from './admin-app/import/import.component';
import { NavbarComponent } from './common/navbar/navbar.component';
import { FooterComponent } from './common/footer/footer.component';
import { FileDialogComponent } from './admin-app/file-dialog/file-dialog.component';
import { SouscripteurComponent } from './admin-app/souscripteurs/souscripteur.component';
import { FileUploadModule } from 'ng2-file-upload';
import { NgFileComponent } from './admin-app/ngfile/ngfile.component';



import { ErrorService } from './admin-app/services/error.service';
import { FileDialogService } from './admin-app/services/file-dialog.service';
import { DownloadChartService } from './admin-app/services/download-chart.service';
import { SouscripteurService } from './admin-app/services/souscripteur.service';
import { SouscripteurServiceClient } from './client-app/services/souscripteur.service';

import { SignupService } from './client-app/services/signup.service';
import { AuthentificationService } from './client-app/services/authentification.service';
import { MainService } from './client-app/services/main.service';
import { ContratService } from './client-app/services/contrat.service';
import { CheckTokenService } from './common/services/check-token.service';
import { CheckRoleService } from './common/services/check-role.service';
import { CheckProfileService } from './common/services/check-profile.service';
import { AuthorizationService } from './common/services/authorization.service';
import Api from './common/services/api.service'



import { LoginComponent } from './admin-app/login/login.component';
import { ErrorDialogComponent } from './core/error-dialog.component';
import { Ng2FileUploadComponent } from './admin-app/ng2file/ng2file-upload.component';
import { AuthComponent } from './client-app/auth/auth.component';
import { SignupComponent } from './client-app/signup/signup.component';
import { ValidateComponent } from './client-app/validate/validate.component';

import { MainComponent } from './client-app/main/main.component';
import { TabComponent } from './client-app/tab/tab.component';
import { PasswordComponent } from './client-app/password/password.component';


import { ToastrModule } from 'ngx-toastr';
import {enableProdMode} from '@angular/core';
enableProdMode();

@NgModule({
  declarations: [
    AppComponent,
    StatistiqueComponent,
    ImportComponent,
    NavbarComponent,
    FooterComponent,
    LoginComponent,
    ErrorDialogComponent,
    FileDialogComponent,
    SouscripteurComponent,
    Ng2FileUploadComponent,
    AuthComponent,
    SignupComponent,
    MainComponent,
    TabComponent,
    ValidateComponent,
    PasswordComponent,
    NgFileComponent
  ],
  imports: [
      BrowserModule,
      FormsModule,
      MaterialModule,
      HttpClientModule,
      FlexLayoutModule,
      AppRoutingModule,
      ReactiveFormsModule,
      BrowserAnimationsModule,
      MatToolbarModule,
      MatSidenavModule,
      MatListModule,
      MatIconModule,
      MatButtonModule,
      MatTabsModule,
      FileUploadModule,
      ToastrModule.forRoot() // ToastrModule added
      
  ],
  entryComponents: [ErrorDialogComponent, NgFileComponent, ValidateComponent, FileDialogComponent, MainComponent, TabComponent,  StatistiqueComponent, SouscripteurComponent],
  providers:
      [ErrorDialogComponent, ErrorService, AuthorizationService, CheckTokenService,CheckProfileService,  CheckRoleService,   ContratService, MainService, AuthentificationService, SignupService, SouscripteurServiceClient, SouscripteurService, AuthService, Api, TokenStorage, FileDialogService, DownloadChartService,
          {
              provide: HTTP_INTERCEPTORS,
              useClass: Interceptor,
              multi : true
          }
      ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts